import { createLogger } from '@sage/sbc.core.utils.ui';
import { Constants } from "../constants";

const logger = createLogger();

const ServiceWorker = {
    register: async () => {
        if ("serviceWorker" in navigator) {
            try {
                let swUrl;
                const useMsw =
                    window.__sbc_config.devtoolsEnabled &&
                    window.__sbc_config?.features["sbc.core.devtools.ui"]
                        ?.useMsw;

                if (useMsw) {
                    const mswUrl =
                        window.importMapOverrides?.getOverrideMap().imports[
                            "msw-service-worker"
                        ];

                    swUrl = `${Constants.SW_URL}?sw=${mswUrl}`;
                } else {
                    swUrl = Constants.SW_URL;
                }

                await navigator.serviceWorker.register(swUrl);

                if (useMsw) {
                    const { registerMsw } = await System.import(
                        "sbc.core.devtools.ui/registerMsw.js"
                    );

                    if (registerMsw) {
                        registerMsw();
                    }
                }
            } catch (error) {
                logger.error(`Global SW Registration failed with ${error}`);
            }
        } else {
            logger.log("ServiceWorker not available in navigator.");
        }
    },
};

export { ServiceWorker };
